export default __webpack_public_path__ + "static/media/status-error.8a0e0d70.svg";